import { ArrowDown, ArrowUp } from "lucide-react";

import { cn } from "@/utils/ui";

import { SortState } from "@components/DataTables/hooks/use-sorting";

type SortableColumnHeaderProps = {
  column: string;
  label: string;
  sortState: SortState;
  onSort: (column: string) => void;
  className?: string;
};

export const SortableColumnHeader = ({
  column,
  label,
  sortState,
  onSort,
  className,
}: SortableColumnHeaderProps) => (
  <div
    className={cn(
      "flex shrink-0 font-head text-xs font-semibold text-foreground-muted",
      className
    )}
  >
    <button
      className={cn(
        // secondary (vibrant blue), not primary-600 — primary is already a
        // dark navy at DEFAULT, so a 600 step read as barely-different from
        // the muted resting color and didn't register as "hoverable".
        "flex items-center gap-1 truncate transition-colors hover:text-secondary",
        sortState.column === column && "font-semibold"
      )}
      onClick={() => onSort(column)}
      type="button"
    >
      {label}
      {sortState.column === column &&
        (sortState.direction === "asc" ? (
          <ArrowUp className="size-4" />
        ) : (
          <ArrowDown className="size-4" />
        ))}
    </button>
  </div>
);
